import { FC, PropsWithChildren } from 'react'

import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { useVipCurrentUser } from 'hooks/useVipCurrentUser'

export const BannerEnabler: FC<PropsWithChildren> = ({ children }) => {
  const { enabled } = useShallowEqualSelector(
    ({ bannerReducer: { enabled } }) => ({
      enabled,
    })
  )

  const isVip = useVipCurrentUser()

  if (enabled && !isVip) {
    return children
  }

  return null
}
